import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

const IconSubsection: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconSubsection" {...props}>
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      aria-hidden="true"
      focusable="false"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="0.5" y1="2.18557e-08" x2="0.5" y2="8" stroke="currentColor" />
      <line
        x1="0.922852"
        y1="7.5"
        x2="11.9998"
        y2="7.5"
        stroke="currentColor"
      />
    </svg>
  </IconSVG>
)

export default IconSubsection
